<!--=================================
=            FILEMANAGER            =
==================================-->

<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Files Manager</div>
      </base-header>
    </v-row>

    <v-row>

      <v-col cols="12" md="3" sm="12" v-for="y in files" :key="y.id">
        <base-card>
          <div slot="card-header">

            <v-list-item class="transparent" dark>
              <v-list-item-content>

                <v-list-item-title class="subtitle-1 mb-1">
                  {{y.title}}
                </v-list-item-title>

              </v-list-item-content>

              <v-list-item-avatar class="rounded-lg " elevation="10" tile size="40" color="transparent">
                <img src="../../assets/images/icons/file1.png">
              </v-list-item-avatar>
            </v-list-item>
          </div>
          <div slot="card-body">
            <v-list-item-subtitle class="pl-5 mt-n5 mb-5">{{y.subtitle}}</v-list-item-subtitle>
          </div>
        </base-card>
      </v-col>  </v-row>

    <v-row>
      <v-col cols="12" md="6" sm="12" v-for="arq in drives" :key="arq.id">
        <base-card>
          <div slot="card-header">

            <v-list-item three-line>
              <v-list-item-content>
                <div class="text-overline mb-4 white--text">
                  {{arq.header}}
                </div>
                <v-list-item-title class="text-h5 mb-1 white--text">
                  {{arq.title}}
                </v-list-item-title>
                <v-list-item-subtitle class="white--text" dark>{{arq.subtitle}}</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar tile size="80" color="transparent"><img
                     :src="require(`../../assets/images/logos/${arq.img}.png`)">
              </v-list-item-avatar>
            </v-list-item>

            <v-card-actions class="pa-3">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-progress-linear :value="arq.value" height="10" striped :color="arq.color"></v-progress-linear>
                  </v-list-item-title>
                  <v-list-item-subtitle class="white--text">
                    {{arq.value}}% usage from service
                  </v-list-item-subtitle>

                </v-list-item-content>
              </v-list-item>
            </v-card-actions>
            </v-card>

          </div>
          <div slot="card-body">

          </div>
        </base-card>
      </v-col>  </v-row>

    <v-row>
      <v-col cols="12" md="12" sm="12">
        <base-card>
          <div slot="card-header">

            Organize FIles
          </div>
          <div slot="card-body">
            <div class="text-center pa-2 mb-10">
              <v-dialog v-model="dialog" persistent max-width="600px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" dark block v-bind="attrs" v-on="on">
                    File Upload
                  </v-btn>
                </template>
                <base-card>
                  <div slot="card-header">

                    File Input
                  </div>
                  <div slot="card-body">

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-file-input show-size dark label="File input"></v-file-input>
                          </v-col>

                          <v-col cols="12" sm="6">
                            <v-text-field label="Name File*" dark required></v-text-field>
                          </v-col>


                          <v-col cols="12" sm="6">
                            <v-autocomplete dark
                                            :items="['Downloads', 'Music', 'Videos', 'Images', 'Books', 'Organization', 'Year 2021', 'Coding', 'Templates']"
                                            label="Tags" multiple></v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-container>

                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" dark @click="dialog = false">
                        Close
                      </v-btn>
                      <v-btn color="red darken-1" dark @click="dialog = false">
                        Save
                      </v-btn>
                    </v-card-actions>

                  </div>
                </base-card>
              </v-dialog>

            </div>

          </div>
        </base-card>
      </v-col>

    </v-row>



  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
  export default {
    components: {
      BaseCard,
      BaseHeader
    },
    data: () => ({
      dialog: false,
      selectedItem: 1,
      files: [{
        id: '1',
        title: 'File ',
        subtitle: 'File projects',
        src: 'file1'
      }, {
        id: '2',
        title: 'Videos',
        subtitle: '458 videos',
        src: 'file2'
      }, {
        id: '3',
        title: 'Musics',
        subtitle: '4858 Music years 80',
        src: ''
      }, {
        id: '4',
        title: 'Lost Frequency',
        subtitle: 'Music ',
        src: 'file3'
      }, {
        id: '5',
        title: 'File Templates',
        subtitle: 'File projects',
        src: 'file1'
      }, {
        id: '6',
        title: 'Videos Youtube',
        subtitle: '458 videos',
        src: 'file2'
      }, {
        id: '7',
        title: 'Books',
        subtitle: 'Books 2022',
        src: 'file4'
      }, {
        id: '8',
        title: 'Imagens',
        subtitle: 'Images Pictures',
        src: 'file3'
      }],
      drives: [{
        id: '19',
        title: 'File ',
        subtitle: 'File projects',
        value: 92,
        img: '1',
        color: 'red'
      }, {
        id: '10',
        title: 'File ',
        subtitle: 'File projects',
        value: 72,
        img: '2',
        color: 'orange'
      }],
      dialog: false,
      selectedItem: 1,

      items2: [{
          text: 'Video',
          icon: 'videocam',
          color: 'primary',
        },
        {
          color: 'primary',
          text: 'Images',
          icon: 'perm_media',
        },
        {
          text: 'Musics',
          icon: 'audiotrack',
          color: 'primary',
        },


      ],
    }),

  }
</script>

<!--====  End of FILEMANAGER  ====-->